import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "activeIndex", "icons", "rotations", "transition", "tagName", "size", "colors", "color", "customColor", "animationType", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { cnBem, forwardRefWithTag } from '@carnica/utils';
import React from 'react';
import { useManyRefs } from '@carnica/utils/hooks';
import { Transition } from 'react-transition-group';
import { getSize } from "../../utils/sizeMap";
import styles from "./styles.pcss";
var cnAnimatedIcon = cnBem('animated-icon', styles);
export var AnimatedIcon = forwardRefWithTag(function (props, ref) {
  var _objectSpread2;
  var className = props.className,
    _props$activeIndex = props.activeIndex,
    activeIndex = _props$activeIndex === void 0 ? 0 : _props$activeIndex,
    icons = props.icons,
    _props$rotations = props.rotations,
    rotations = _props$rotations === void 0 ? [] : _props$rotations,
    _props$transition = props.transition,
    transition = _props$transition === void 0 ? 200 : _props$transition,
    _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'span' : _props$tagName,
    _props$size = props.size,
    size = _props$size === void 0 ? 'm' : _props$size,
    _props$colors = props.colors,
    colors = _props$colors === void 0 ? [] : _props$colors,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    customColor = props.customColor,
    _props$animationType = props.animationType,
    animationType = _props$animationType === void 0 ? 'cubic' : _props$animationType,
    style = props.style,
    otherProps = _objectWithoutProperties(props, _excluded);
  var refs = useManyRefs(icons.length);
  var _icons = _slicedToArray(icons, 1),
    FirstIcon = _icons[0];
  var Tag = tagName;
  return /*#__PURE__*/React.createElement(Tag, _extends({}, otherProps, {
    className: cnAnimatedIcon({
      size: size
    }, [className]),
    ref: ref,
    style: _objectSpread(_objectSpread({}, style), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, '--icon-size', getSize(size)), _defineProperty(_objectSpread2, '--animate-icon-transition', "".concat(transition, "ms")), _objectSpread2), typeof rotations[activeIndex] === 'number' && _defineProperty({}, '--animate-icon-rotation', "rotate(".concat(rotations[activeIndex], "deg)"))),
    "data-t-id": "components-AnimatedIcon"
  }), icons.length === 1 ? /*#__PURE__*/React.createElement(FirstIcon, {
    color: colors[activeIndex] || customColor || color,
    size: size
  }) : icons.map(function (Icon, index) {
    return /*#__PURE__*/React.createElement(Transition, {
      in: activeIndex === index,
      key: cnAnimatedIcon({
        index: index
      }),
      nodeRef: refs[index],
      timeout: transition,
      unmountOnExit: true
    }, function (animate) {
      return /*#__PURE__*/React.createElement(Icon, {
        className: cnAnimatedIcon('icon', {
          animate: animate,
          animationType: animationType
        }),
        color: colors[index] || customColor || color,
        ref: refs[index],
        size: size
      });
    });
  }));
});